import React from 'react';
import { useState, useRef } from 'react';
import RecipeInstructions from "../RecipeInstructions"
import "./RecipeInstructionElement.css"

function RecipeInstructionElement({ inputInstruction, changeHandler = null, depth = null}) {
    
    const [isActive, setIsActive] = useState(false);
    const newRef = useRef(null);
    const editable = changeHandler ? true : false;
    if (!inputInstruction.Instruction_During) {
        inputInstruction.Instruction_During = []
    }
         
    function onChange(e) {
        const name = e.target.id
        const value = e.target.value;
        if (e.target.checkValidity()) {
            const newInstruction = {
                ...inputInstruction,
                [name]:value
            }      
            inputInstruction = newInstruction
            changeHandler(newInstruction, inputInstruction.index)
        }
    }

    function onDuringChange(duringInstructions) {
        const newInstruction = {
            ...inputInstruction,
            Instruction_During:duringInstructions
        }
        inputInstruction = newInstruction
        changeHandler(newInstruction, inputInstruction.index)
    }

    function onEditClick() {
        setIsActive(!isActive)
    }

    function deleteInstruction() {
        changeHandler(null, inputInstruction.index)
    }

    return (
        <div className="instruction-container-container row">
            <div className={"container-div instruction-container hoverable-element instruction-" + inputInstruction.index} ref={newRef} >
                {editable ? <div className="top-right">
                    <button type="button" onClick={onEditClick}>{isActive ? "Done" : "Edit"}</button>
                    <button type="button" onClick={deleteInstruction}>X</button>
                </div> : null}
                <div className="instruction-text-container" style={{ display: !isActive ? 'flex' : 'none' }}>
                    <p>Time: {inputInstruction.Instruction_Time} mins</p>
                    <p className="Instruction-Text-p">{inputInstruction.Instruction_Text}</p>
                </div>
                <div className="instruction-form-container" style={{ display: isActive ? 'flex' : 'none' }}>
                    <label className="instruction-form-element">Time Taken:
                        <input type="number"
                            value={inputInstruction.Instruction_Time}
                            id="Instruction_Time"
                            name="Instruction_Time"
                            placeholder="minutes"
                            onChange={onChange}
                            min="0"
                            max="2147483647"
                        />
                    </label>
                    <label className="instruction-form-element text-area">Instruction Text:
                        <textarea id="Instruction_Text"
                            name="Instruction_Text"
                            rows="6"
                            cols="50"
                            value={inputInstruction.Instruction_Text}
                            placeholder="Write Instruction Here..."
                            maxLength="2048"
                            onChange={onChange} />
                    </label>
                </div>
            </div>
            {
             (depth < 3) ? (<RecipeInstructions
                inputInstructions={inputInstruction.Instruction_During}
                showInstructions={true}
                changeHandler={changeHandler ? onDuringChange : null}
                depth={depth + 1}
            />): null}
        </div>
    )
}

export default RecipeInstructionElement;